export default __webpack_public_path__ + "static/media/icon-future-order.939af77a.svg";